import { useSinkRef } from "../utils/sink";

// Glowing cut-out frame with tech corner brackets. Wrap any cutout image.
// Bends & sinks as the cursor approaches (brand gel tactility).
export const GlowFrame = ({ children, className = "", tone = "volt" }) => {
  const sinkRef = useSinkRef();
  const c = tone === "cyan" ? "border-cyan/60" : tone === "clay" ? "border-accent/60" : "border-volt/60";
  return (
    <div ref={sinkRef} className={`glow-frame group/frame relative ${className}`}>
      <span aria-hidden="true" className={`gf-corner left-2 top-2 border-l-2 border-t-2 ${c}`} />
      <span aria-hidden="true" className={`gf-corner right-2 top-2 border-r-2 border-t-2 ${c}`} />
      <span aria-hidden="true" className={`gf-corner bottom-2 left-2 border-b-2 border-l-2 ${c}`} />
      <span aria-hidden="true" className={`gf-corner bottom-2 right-2 border-b-2 border-r-2 ${c}`} />
      {children}
    </div>
  );
};
